module.exports = __webpack_public_path__ + "static/media/average-chart.67a9f067.svg";